import { AdvancedMarker } from '@vis.gl/react-google-maps';
import type { LineString } from 'geojson';

import { DEFAULT_MARKER_COLOR } from '@atom/utilities/colorUtilities';

import LineStringMarker from '../markers/LineStringMarker';
import {
  lineStringPath,
  MARKER_STYLE,
  resolveAnchor,
  resolveZIndex,
} from '../markers/markerUtilities';

import { EditTargetView } from './drawingTypes';

type StaticTargetMarkerProps = {
  target: EditTargetView;
};

const StaticTargetMarker = ({ target }: StaticTargetMarkerProps) => {
  if (!target.coordinates) {
    return null;
  }

  const path =
    target.geometry?.type === 'LineString'
      ? lineStringPath(target.geometry as LineString)
      : null;

  return (
    <>
      {path && (
        <LineStringMarker
          path={path}
          color={target.color ?? DEFAULT_MARKER_COLOR}
          isActive={false}
          onClick={() => {}}
        />
      )}
      <AdvancedMarker
        position={target.coordinates}
        zIndex={resolveZIndex(target.type, target.isActive)}
        {...resolveAnchor(target.type, target.isActive)}
        style={MARKER_STYLE}
      >
        {target.isActive ? target.mapActiveIcon : target.mapIcon}
      </AdvancedMarker>
    </>
  );
};

export default StaticTargetMarker;
